import {
    Col,
    Row,
} from 'reactstrap';

import ChipIcon from '../ChipIcon';

const EmissionReductionTargets = ({
    t,
    targets,
}) => (
    <>
        <p className="overview-esg-rating__eyebrow mb-2">
            {t('Emission Reduction Targets')}
        </p>
        <Row className="g-2 mb-3">
            {(targets || []).map((item) => (
                <Col xs="12" md="6" key={item.key}>
                    <div className={`overview-esg-rating__metric-card overview-esg-rating__metric-card--target${item.emphasized ? ' overview-esg-rating__metric-card--emphasized' : ''}`}>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="overview-esg-rating__metric-label">
                                {t(item.label)}
                            </span>
                            <ChipIcon />
                        </div>
                        <span className="overview-esg-rating__metric-value overview-esg-rating__target-value">
                            {item.value}
                        </span>
                        {item.highlight && (
                            <span className="overview-esg-rating__highlight">
                                {t(item.highlight)}
                            </span>
                        )}
                        <span className="overview-esg-rating__hint">
                            {t(item.hint)}
                        </span>
                    </div>
                </Col>
            ))}
        </Row>
    </>
);

export default EmissionReductionTargets;
